import React, { useState, useContext } from "react";
import EditProfileStyle from "./EditProfileStyle.module.css";
import axios from "axios";
import {Link} from "react-router-dom";
//import useContext
import { AuthContext } from "../../../context/AuthContextProvider";
//import component
import { ButtonEdit } from "../../../components/UI/Button";
//toastify
import {toastify} from '../../../helper/toast'


//start component
const EditProfile = () => {
  //use context
  const profileValue = useContext(AuthContext);
  //use states

  const [value, setValue] = useState({
    fullName: profileValue.studentData.fullName,
    nationalId: profileValue.studentData.nationalId,
    email: profileValue.studentData.email,
    phoneNumber: profileValue.studentData.phoneNumber,
    role: profileValue.studentData.role,
    birthDate: profileValue.studentData.birthDate,
  });

  console.log(profileValue.studentData);
  const changeHandler = (event) => {
    setValue({ ...value, [event.target.name]: event.target.value });
  };
  const submitHandler = (event) => {
    event.preventDefault();
    const data = {
      fullName: value.fullName,
      email: value.email,
      phoneNumber: value.phoneNumber,
      birthDate: value.birthDate,
      nationalId: value.nationalId,
    };
    if (
      value.fullName &&
      value.email &&
      value.birthDate &&
      value.nationalId &&
      value.phoneNumber
    )
      axios.put(`https://academy-nyctophile.herokuapp.com/api/student/${profileValue.studentData._id}`, data, {
        headers: { "x-auth-token": profileValue.token }
      }).then(response=>{
        profileValue.updateData(response.data.result)
        console.log(response.data.result)
        toastify("تغییرات با موفقیت ثبت شد","success")
      });
     else{
      toastify("فیلدها را بدرستی پر کنید","error")
     } 
  };
  return (
    <>
      {" "}
      <h2 style={{ marginTop: "10px", textAlign: "center", color: "#f9f9f9" }}>
        تغییر پروفایل
      </h2>
      {profileValue.isAuth ? <> <div className={EditProfileStyle.container}>
        <div className={EditProfileStyle.inputContainer}>
          {" "}
          <label className={EditProfileStyle.label}>نام و نام خانوادگی</label>
          <input
          name="fullName"
            onChange={changeHandler}
            value={value.fullName}
            className={EditProfileStyle.input}
          />
        </div>

        <div className={EditProfileStyle.inputContainer}>
          {" "}
          <label className={EditProfileStyle.label}>ایمیل</label>
          <input
          name="email"
            onChange={changeHandler}
            value={value.email}
            className={EditProfileStyle.input}
          />
        </div>
        <div className={EditProfileStyle.inputContainer}>
          {" "}
          <label className={EditProfileStyle.label}>نقش</label>
          <input
          name="role"
            onChange={changeHandler}
            value={value.role}
            className={EditProfileStyle.input}
          />
        </div>
        <div className={EditProfileStyle.inputContainer}>
          {" "}
          <label className={EditProfileStyle.label}>شماره ملی </label>
          <input
          name="nationalId"
            onChange={changeHandler}
            value={value.nationalId}
            className={EditProfileStyle.input}
          />
        </div>
        <div className={EditProfileStyle.inputContainer}>
          {" "}
          <label className={EditProfileStyle.label}>شماره تماس</label>
          <input
          name="phoneNumber"
            onChange={changeHandler}
            value={value.phoneNumber}
            className={EditProfileStyle.input}
          />
        </div>
        <div className={EditProfileStyle.inputContainer}>
          {" "}
          <label className={EditProfileStyle.label}>تاریخ تولد</label>
          <input
          name="birthDate"
            onChange={changeHandler}
            value={value.birthDate}
            className={EditProfileStyle.input}
          />
        </div>
      </div>
      <ButtonEdit type="submit" onClick={submitHandler}>ثبت تغییرات</ButtonEdit> </> : <h3 style={{marginTop:"100px"}}><Link style={{ fontSize:"22px"}} to='/Login'>لطفا وارد حسابتان شوید</Link></h3> }
     
    </>
  );
};

export default EditProfile;
